function loginDropdown(buttonElement: HTMLElement | null): void {
    if (!buttonElement) return;

    const targetMenu = buttonElement.getAttribute('data-menu') ?? '';
    const menuElement = document.getElementById(targetMenu) as HTMLDivElement | null;
    if (targetMenu === null || menuElement === null) return;

    const dropdownItems = Array.from(
        menuElement.querySelectorAll('button,[href],[tabindex]:not([tabindex="-1"]') ?? [],
    );

    function isDropDownVisible(): boolean {
        const dropDownState = menuElement?.getAttribute('data-open');
        if (dropDownState === null || dropDownState === '') return false;
        return dropDownState?.toLowerCase() === 'true';
    }

    function toggleDropdownMenu(focusFirst = true) {
        if (isDropDownVisible()) {
            buttonElement?.setAttribute('aria-expanded', 'false');
            menuElement?.setAttribute('data-open', 'false');
            menuElement?.setAttribute('aria-hidden', 'true');
        } else {
            buttonElement?.setAttribute('aria-expanded', 'true');
            menuElement?.setAttribute('data-open', 'true');
            menuElement?.setAttribute('aria-hidden', 'false');

            if (focusFirst) {
                const firstItem = menuElement?.querySelector('a') as HTMLAnchorElement;
                if (firstItem) firstItem.focus();
            }
        }
    }

    function toggleDropdown(e: Event) {
        e.preventDefault();
        toggleDropdownMenu();
    }

    function dropDownA11y(e: KeyboardEvent) {
        if (!dropdownItems.length) return;

        if ([27, 32, 38, 40].includes(e.keyCode) || ['ArrowUp', 'ArrowDown', 'Escape'].includes(e.key)) {
            toggleDropdownMenu(false);
            e.preventDefault();
        }

        if (
            isDropDownVisible() &&
            (e.key === 'Tab' || e.keyCode === 9) &&
            e.shiftKey &&
            document.activeElement === buttonElement
        ) {
            const lastMenuItem = dropdownItems[dropdownItems.length - 1] as HTMLElement;
            lastMenuItem.focus();
            e.preventDefault();
        }
    }

    function keydownDropdown(e: KeyboardEvent) {
        if (!isDropDownVisible() || !dropdownItems.length) return;

        if (e.key === 'Tab' && !e.shiftKey) {
            const inFocus = document.activeElement;
            const lastMenuItem = dropdownItems[dropdownItems.length - 1];
            if (lastMenuItem === inFocus) {
                buttonElement?.focus();
                e.preventDefault();
            }
        }
        if (e.key === 'Escape' || e.keyCode === 27) {
            toggleDropdownMenu();
            e.preventDefault();
        }
    }

    function clickOutsideMenu(e: MouseEvent) {
        const clickedElm = e.target as Node;

        if (!isDropDownVisible() || !clickedElm) return;

        if (!menuElement?.contains(clickedElm) && !buttonElement?.contains(clickedElm)) {
            toggleDropdownMenu();
        }
    }

    buttonElement.addEventListener('click', toggleDropdown);
    buttonElement.addEventListener('keydown', dropDownA11y);
    menuElement.addEventListener('keydown', keydownDropdown);
    document.addEventListener('mousedown', clickOutsideMenu);
}

export default loginDropdown;
